import Api from '../api';
import {
  ADMIN_BALANCE_NOTIFICATIONS, ADMIN_BALANCE_NOTIFICATIONS_URL,
  ADMIN_BALANCE_USAGE, ADMIN_BALANCE_USAGE_URL,
  ADMIN_BALANCE_USAGE_ALL, ADMIN_BALANCE_USAGE_ALL_URL
} from '../lib/constant';
import {handleAPIDispatch} from '../lib/utils';

// All orgs, one call. The server sorts most-urgent (smallest runway) first,
// so the table does not re-sort and fight it.
export function getBalanceNotifications(lowBalanceOnly = false) {
  const url = `${ADMIN_BALANCE_NOTIFICATIONS_URL}?low_balance_only=${lowBalanceOnly}`;
  return handleAPIDispatch(Api.get(url), ADMIN_BALANCE_NOTIFICATIONS);
}

// One org's wallets + recent transactions + DAILY consumption series.
// days is capped server-side at 45; 30 is the default the chart wants.
export function getBalanceUsage(orgId, days = 30) {
  const url = `${ADMIN_BALANCE_USAGE_URL.replace('{orgId}', orgId)}?days=${days}`;
  return handleAPIDispatch(Api.get(url), ADMIN_BALANCE_USAGE);
}

// Fleet-wide table feed: one row per (org, message_type) with balance, 7d/30d
// averages AND a compact daily array. One call serves both the table and every
// row's chart — the per-org endpoint below is no longer needed to draw one.
export function getBalanceUsageAll(days = 30, withBalanceOnly = false) {
  const url = `${ADMIN_BALANCE_USAGE_ALL_URL}?days=${days}&with_balance_only=${withBalanceOnly}`;
  return handleAPIDispatch(Api.get(url), ADMIN_BALANCE_USAGE_ALL);
}
